import { TextInput } from 'gu-ui-kit'
import React from 'react'
import MaskedInput from 'react-text-mask'

const renderMaskedInput = ({
  input,
  meta: { touched, error, submitting },
  pipe = null,
  mask = (value) => Array(value.length).fill(/[\d.]/),
  placeholderChar = '\u2000',
  t = (val) => val,
  helperText = null,
  hidden = false,
  placeholder = '',
  fullWidth = false,
  type = 'text',
  label = '',
  disabled = false,
  ...rest
}) => (
  <MaskedInput
    mask={mask}
    pipe={pipe}
    placeholder={placeholder}
    placeholderChar={placeholderChar}
    disabled={submitting || disabled}
    type={type}
    fullWidth={fullWidth}
    error={touched && error}
    hidden={hidden}
    helperText={touched && error ? t(error) : helperText}
    label={label}
    {...input}
    {...rest}
    render={(ref, props) => <TextInput ref={ref} {...props} />}
  />
)

export default renderMaskedInput
